import { render, staticRenderFns } from "./ChangeHeterogenityModal.vue?vue&type=template&id=e28c2126&scoped=true&lang=html&"
import script from "./ChangeHeterogenityModal.vue?vue&type=script&lang=js&"
export * from "./ChangeHeterogenityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28c2126",
  null
  
)

export default component.exports